import { afterNextRender, ChangeDetectionStrategy, Component, computed, input, linkedSignal, signal } from '@angular/core';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-header-count-button',
  templateUrl: './header-count-button.component.html',
  styleUrls: ['./header-count-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RmaIconComponent],
})
export class HeaderCountButtonComponent {
  private readonly rendered = signal(false);

  private readonly increased = linkedSignal<number, boolean>({
    source: () => this.count() ?? 0,
    computation: (current, previous) => (previous === undefined ? false : current > previous.source),
  });

  public readonly title = input('');
  public readonly matIcon = input.required<'favorite' | 'group'>();
  public readonly count = input<number | null>(null);
  public readonly srSubtitle = input('');

  public readonly ariaLabel = computed(() => (this.count() ? `${this.count()} ${this.srSubtitle()}` : this.srSubtitle()));

  public readonly badgeAnimation = computed(() => {
    const increased = this.increased();
    return this.rendered() && increased ? 'rma-animate-badge-pop' : '';
  });

  public constructor() {
    afterNextRender(() => this.rendered.set(true));
  }
}
